import React from 'react'


const Loading = () => {
  return (
    <div className='text-center my3'>
        <img src='./images/loading.gif' alt='Loading . . .'></img>
    </div>
  )
}

export default Loading